import dataimg from "../../Assets/internsala.png"
import dataimg1 from "../../Assets/amezon.png"

let InterShipData = [
    {
        title: "Internship",
        company: "Beanget It solution pvt.Ltb.",
        location: "India,Bhopal",
        Duration: "2 months",
        picture: {dataimg},
        stipend: "2000-3000"
    },

    {
        title: "Internship",
        company: "L&T Technology Services",
        location: "India,Vadodara",
        Duration: "3 months",
        picture: {dataimg1},
        stipend: "3000-4000"
    },

    {
        title: "Internship",
        company: "Oracle Financial Services Software",
        location: "India,Bangalore",
        Duration: "5 months",
        stipend: "4000-5000",
    },

    {
        title: "Internship",
        company: "HCL Technologies",
        location: "India,Bhopal",
        Duration: "6 months",
        stipend: "6000-8000",
    },

    {
        title: "Internship",
        company: "HCL Technologies",
        location: "India,Bhopal",
        Duration: "6 months",
        stipend: "6000-8000",
    },

    {
        title: "Internship",
        company: "HCL Technologies",
        location: "India,Bhopal",
        Duration: "6 months",
        stipend: "6000-8000",
    },

    {
        title: "Internship",
        company: "HCL Technologies",
        location: "India,Bhopal",
        Duration: "6 months",
        stipend: "6000-8000",
    }
]
export default InterShipData;
